/**
 * 두 문장의 차이를 구간으로 나눕니다 (품질 검토 수정안 비교용).
 * 짧은 글은 글자 단위, 긴 글은 단어 단위 LCS로 비교합니다.
 */
export type DiffSegment = { type: 'same' | 'removed' | 'added'; text: string };

const tokenize = (text: string, byChar: boolean) => (byChar ? Array.from(text) : text.split(/(\s+)/).filter(Boolean));

export const diffText = (before: string, after: string): DiffSegment[] => {
  const byChar = before.length <= 1200 && after.length <= 1200;
  const a = tokenize(before, byChar);
  const b = tokenize(after, byChar);
  const rows = a.length + 1;
  const cols = b.length + 1;
  const table = new Uint16Array(rows * cols);
  for (let i = a.length - 1; i >= 0; i -= 1) {
    for (let j = b.length - 1; j >= 0; j -= 1) {
      table[i * cols + j] = a[i] === b[j]
        ? table[(i + 1) * cols + j + 1] + 1
        : Math.max(table[(i + 1) * cols + j], table[i * cols + j + 1]);
    }
  }

  const segments: DiffSegment[] = [];
  const push = (type: DiffSegment['type'], text: string) => {
    const last = segments[segments.length - 1];
    if (last && last.type === type) last.text += text;
    else segments.push({ type, text });
  };
  let i = 0;
  let j = 0;
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) {
      push('same', a[i]);
      i += 1;
      j += 1;
    } else if (table[(i + 1) * cols + j] >= table[i * cols + j + 1]) {
      push('removed', a[i]);
      i += 1;
    } else {
      push('added', b[j]);
      j += 1;
    }
  }
  while (i < a.length) push('removed', a[i++]);
  while (j < b.length) push('added', b[j++]);
  return segments;
};
